<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button
            icon="keyboard_backspace"
            @click="goBack"
            >Back</vs-button
          >
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Edit {{ campaignDescription["campaign_name"] }} Steps</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="4"
          vs-sm="4"
          vs-xs="12"
        >
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>
      <div class="vx-row mb-6"></div>

      <div class="vx-row mb-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <h5>Master Steps</h5>
          </div>
        </vs-col>
        <v-multiselect-listbox
          :options="masterSteps"
          :reduce-display-property="option => option.steps"
          :reduce-value-property="option => option.id"
          no-options-found-text="No steps found"
          v-model="selectedMasterSteps"
          no-selected-options-found-text="No selected steps found"
        >
        </v-multiselect-listbox>
      </div>
      <div class="vx-row mb-6">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <h5>Client Steps</h5>
          </div>
        </vs-col>
        <v-multiselect-listbox
          :options="clientCmapignSteps"
          :reduce-display-property="option => option.steps"
          :reduce-value-property="option => option.id"
          no-options-found-text="No steps found"
          v-model="selectedClientCampaignSteps"
          no-selected-options-found-text="No selected steps found"
        >
        </v-multiselect-listbox>
      </div>
      <div class="vx-row mb-6" v-if="customSteps.length != 0">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center">
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <h5>Custom Steps</h5>
          </div>
        </vs-col>
        <v-multiselect-listbox
          :options="customSteps"
          :reduce-display-property="option => option.steps"
          :reduce-value-property="option => option.id"
          no-options-found-text="No steps found"
          v-model="selectedCustomCampaignSteps"
          no-selected-options-found-text="No selected steps found"
        >
        </v-multiselect-listbox>
      </div>

      <div class="float-right p-5">
        <vs-button icon="keyboard_tab" @click="goNext()">Next</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Vue from "vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vMultiselectListbox from "vue-multiselect-listbox";
import defineAbilitiesFor from "@/config/abilities";
import moduleMasterStepsManagement from "@/store/campaign-management/master-steps-management/moduleMasterStepsManagement.js";
import moduleClientCampaignStepsManagement from "@/store/campaign-management/client-campaign-steps-management/moduleStepsManagement.js";
import "vue-multiselect-listbox/src/scss/vue-multi-select-listbox.scss";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
Vue.component("v-multiselect-listbox", vMultiselectListbox);
export default {
  data: () => ({
    selected_campaign_clients: [],
    selected_campaign: null,
    user_id: null,
    user_role: null,
    companySearchComponentKey: 0,

    abilities: null,
    selectedMasterSteps: [],
    selectedClientCampaignSteps: [],
    paginationAttr: {
      page_no: 1,
      per_page: 100
    },
    campaignDescription: [],
    masterSteps: [],
    clientCmapignSteps: [],
    getSeletectedCampaignClients: [],
    customSteps: [],
    selectedCustomCampaignSteps: []
  }),
  components: {
    CampaignAutocomplete
  },
  watch: {},
  methods: {
    goToCampaignSteps(campaignId) {
      this.$router.push({
        path: `/campaigns/arranged-steps/` + campaignId
      });
    },
    fetchCampaignCustomSteps() {
      let self = this;

      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignCustomSteps",
          this.$route.params.campaignId
        )
        .then(res => {
          self.customSteps = res.data;
          console.log(self.customSteps);
        })
        .catch(err => {
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchMasterSteps() {
      let self = this;
      this.$store
        .dispatch(
          "MasterStepsManagement/fetchAllMasterSteps",
          this.paginationAttr
        )
        .then(res => {
          self.masterSteps = moduleMasterStepsManagement.state.steps.datas;
          self.fetchClientSteps();
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchClientSteps() {
      let self = this;
      self.$store
        .dispatch(
          "ClientCampaignStepsManagement/fetchAllClientCampaignSteps",
          self.paginationAttr
        )
        .then(res => {
          this.clientCmapignSteps =
            moduleClientCampaignStepsManagement.state.steps.datas;
          self.fetchCampaignCustomSteps();
          self.init();
          self.fetchCamapignSteps();
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    goNext() {
      console.log("sdfsdfsdf" , this.selectedMasterSteps);

      //  this.selectedMasterSteps = Object.assign({}, this.selectedMasterSteps);
      //       this.selectedClientCampaignSteps = Object.assign({}, this.selectedClientCampaignSteps);

      let newObj = {};
      newObj.master_steps = this.selectedMasterSteps;
      newObj.client_steps = this.selectedClientCampaignSteps;
      newObj.custom_steps = this.selectedCustomCampaignSteps;
      if (this.selected_campaign == null) {
        newObj.campaign_id = this.$route.params.campaignId;
      } else {
        newObj.campaign_id = this.selected_campaign["id"];
      }

      this.$store
        .dispatch("campaignsManagement/editCampaignSteps", newObj)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Campaign Steps",
              text: res.data.message
            });
          } else {
            // this.$vs.notify({
            //   color: "success",
            //   title: "Campaign Steps",
            //   text: "The campaign steps was saved successfully"
            // });
            this.$router.push({
              path: `/campaigns/steps-start-end-assign/` + newObj.campaign_id
            });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    init() {
      let self = this;
      const campaignId = this.$route.params.campaignId;
      self.$store
        .dispatch("campaignsManagement/fetchCampaign", campaignId)
        .then(res => {
          self.campaignDescription = res.data;
          self.campaignDescription.client_campaign_association.map(function(
            scc_ele
          ) {
            self.clientCmapignSteps.filter(function(e) {
              if (scc_ele.id == e.client_id) {
                self.getSeletectedCampaignClients.push(e);
              }
            });
          });
          self.clientCmapignSteps = self.getSeletectedCampaignClients;
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchCamapignSteps() {
      let self = this;
      const campaignId = this.$route.params.campaignId;
      this.campaignId = this.$route.params.campaignId;
      this.$store
        .dispatch("campaignsManagement/fetchArrangedCampaignSteps", campaignId)
        .then(res => {
          this.campaign_steps = JSON.parse(res.data);
          this.campaign_steps.map(function(ele) {
            if (ele.master_steps != null) {
              self.selectedMasterSteps.push(ele.steps);
            }
            if (ele.custom_steps != null) {
              self.selectedCustomCampaignSteps.push(ele.steps);
            }
            if (ele.campaign_client_steps != null) {
              self.selectedClientCampaignSteps.push(ele.steps);
            }



            self.selectedMasterSteps = self.selectedMasterSteps.filter((value, index, array) => array.indexOf(value) === index);

            self.selectedCustomCampaignSteps = self.selectedCustomCampaignSteps.filter((value, index, array) => array.indexOf(value) === index);
            self.selectedClientCampaignSteps = self.selectedClientCampaignSteps.filter((value, index, array) => array.indexOf(value) === index);



          });
        })
        .catch(err => {
          console.log(err);
                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {
    this.fetchMasterSteps();
          if (localStorage.getItem('reloaded-2')) {
        // The page was just reloaded. Clear the value from local storage
        // so that it will reload the next time this page is visited.
        localStorage.removeItem('reloaded-2');
    } else {
        // Set a flag so that we know not to reload the page twice.
        localStorage.setItem('reloaded-2', '1');
        location.reload(); }
  },

  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleClientCampaignStepsManagement.isRegistered) {
      self.$store.registerModule(
        "ClientCampaignStepsManagement",
        moduleClientCampaignStepsManagement
      );
      moduleClientCampaignStepsManagement.isRegistered = true;
    }
    if (!moduleMasterStepsManagement.isRegistered) {
      self.$store.registerModule(
        "MasterStepsManagement",
        moduleMasterStepsManagement
      );
      moduleMasterStepsManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      self.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  }
};
</script>
<style>
.msl-search-list-input {
  margin-bottom: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}

.msl-searchable-list__item {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
  height: 50px;
}
.msl-multi-select__actions {
  font-size: 25px;
}

.msl-multi-select {
  width: 100%;
}
</style>
